import {DataObjectId, Hub, SandboxTree} from 'yougile-model'
import {Sync} from '@client/sync'

export const getHub = (
  idOriginalChat: DataObjectId
): {box: SandboxTree; hub: Hub} => {
  const currentSandBox = Sync.getCurrentSandbox()
  const currentHub = currentSandBox.getHub(idOriginalChat)
  if (currentHub) {
    return {box: currentSandBox, hub: currentHub}
  }

  const newsSandBox = Sync.newsSandbox
  const newsHub = newsSandBox?.getHub(idOriginalChat)
  if (newsHub) {
    return {box: newsSandBox, hub: newsHub}
  }

  const profileSandBox = Sync.getProfile()
  const profileHub = profileSandBox.getHub(idOriginalChat)

  return {box: profileSandBox, hub: profileHub}
}
